__webpack_require__.p = "/portfolio-dar-amenda/";